export default __webpack_public_path__ + "static/media/social-row.b61dc2df.jpg";